import React, { useEffect, useState, useRef } from "react";
import { api } from "../../lib/api";
import { PageHead } from "../../components/admin/AdminBits";
import { Upload, Trash2, Copy, FileText } from "lucide-react";
import { toast } from "sonner";

export default function AdminMedia() {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();
  const load = () => api.get("/admin/media").then(({ data }) => setFiles(data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const list = Array.from(e.target.files); if (!list.length) return;
    setUploading(true);
    try {
      for (const f of list) { const fd = new FormData(); fd.append("file", f); await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }); }
      toast.success("Качено"); load();
    } catch { toast.error("Грешка"); } finally { setUploading(false); e.target.value = ""; }
  };
  const del = async (id) => { if (window.confirm("Изтриване?")) { await api.delete(`/admin/media/${id}`); load(); } };
  const copy = (url) => { navigator.clipboard.writeText(url); toast.success("URL копиран"); };
  const isImg = (ct) => (ct || "").startsWith("image/");

  return (
    <div data-testid="admin-media">
      <PageHead title="Медия" desc="Качвайте изображения и документи. Копирайте URL за вмъкване навсякъде."
        action={<><input ref={fileRef} type="file" multiple onChange={upload} className="hidden" data-testid="media-input" />
          <button onClick={() => fileRef.current?.click()} disabled={uploading} className="btn-gold px-4 py-2.5 rounded-sm text-sm flex items-center gap-2" data-testid="media-upload-btn"><Upload size={16} /> {uploading ? "Качване..." : "Качи файлове"}</button></>} />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
        {files.map((f) => (
          <div key={f.id} className="bg-white border border-stone overflow-hidden group" data-testid={`media-${f.id}`}>
            <div className="aspect-square bg-stone flex items-center justify-center overflow-hidden">
              {isImg(f.content_type) ? <img src={f.url} alt="" className="w-full h-full object-cover" /> : <FileText size={32} className="text-gold" />}
            </div>
            <div className="p-2">
              <p className="text-xs text-charcoal/60 truncate">{f.filename}</p>
              <div className="flex justify-between mt-1.5">
                <button onClick={() => copy(f.url)} className="text-gold hover:text-gold-dark"><Copy size={14} /></button>
                <button onClick={() => del(f.id)} className="text-charcoal/40 hover:text-red-500"><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
        {files.length === 0 && <p className="text-charcoal/50 col-span-full">Няма качени файлове.</p>}
      </div>
    </div>
  );
}
